import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import { SearchResultType } from 'Type/Search.type';

import { SEARCH_RESULTS_TAB_LABELS } from './SearchResultsTab.config';

import './SearchResultsTab.style';

/** @namespace PeggysagePwa/Component/SearchResultsTab/Component */
export class SearchResultsTabComponent extends PureComponent {
    static propTypes = {
        searchResult: SearchResultType.isRequired,
        isActive: PropTypes.bool.isRequired,
        onTabClick: PropTypes.func.isRequired
    };

    render() {
        const {
            searchResult: {
                type,
                __typename: typeName,
                total_count: count
            },
            isActive,
            onTabClick
        } = this.props;

        if (!count) {
            return null;
        }

        const title = SEARCH_RESULTS_TAB_LABELS[type] ?? typeName;

        return (
            <button
              type="button"
              block="SearchResultsTab"
              mods={ { isActive } }
              onClick={ onTabClick }
            >
                <span block="SearchResultsTab" elem="Title">{ title }</span>
                <span block="SearchResultsTab" elem="Count">{ count }</span>
            </button>
        );
    }
}

export default SearchResultsTabComponent;
